import React from 'react';

const alertaAdministracion = (
    <div className="alert alert-warning mt-2 mb-0" style={{ fontSize: '0.85rem' }}>
        <i className="fas fa-exclamation-triangle mr-1"></i>
        <strong>Nota:</strong> Los permisos de administración otorgan acceso a funciones críticas del sistema.
    </div>
);

/** Muestra Ver Suscripción en Administración y con el nombre Administrar Suscripción. */
export function aplicarPermisoAdministrarSuscripcion(listaPermisos = []) {
    return listaPermisos.map((permiso) => {
        if (permiso?.slug !== 'ver_suscripcion') {
            return permiso;
        }
        return {
            ...permiso,
            name: 'Administrar Suscripción',
            categoria: 'administracion',
        };
    });
}

export function buildPermisosRolSecciones({
    permisosGenerales,
    permisosAdministracion,
    permisosAgenda,
    permisosPersonal,
    permisosReportes,
    permisosPacientes,
    permisosFacturacion,
    permisosContabilidad,
    permisosIndicadores,
    permisosConfiguracion,
    permisosLaboratorio,
}) {
    return [
        {
            key: 'generales',
            title: 'Permisos Generales',
            icon: 'fas fa-cog',
            titleStyle: { color: '#007bff' },
            permissions: permisosGenerales,
            selectAllId: 'selectAllGenerales',
        },
        {
            key: 'administracion',
            title: 'Permisos de Administración',
            icon: 'fas fa-users-cog',
            titleStyle: { color: '#dc3545' },
            permissions: permisosAdministracion,
            selectAllId: 'selectAllAdministracion',
            footer: alertaAdministracion,
        },
        {
            key: 'agenda',
            title: 'Permisos de Agenda',
            icon: 'fas fa-calendar-alt',
            titleStyle: { color: '#17a2b8' },
            permissions: permisosAgenda,
            selectAllId: 'selectAllAgenda',
        },
        {
            key: 'personal',
            title: 'Permisos de Personal',
            icon: 'fas fa-users',
            titleStyle: { color: '#fd7e14' },
            permissions: permisosPersonal,
            selectAllId: 'selectAllPersonal',
        },
        {
            key: 'reportes',
            title: 'Permisos de Reportes',
            icon: 'fas fa-chart-bar',
            titleStyle: { color: '#20c997' },
            permissions: permisosReportes,
            selectAllId: 'selectAllReportes',
        },
        {
            key: 'pacientes',
            title: 'Permisos de Pacientes',
            icon: 'fas fa-user-injured',
            titleStyle: { color: '#28a745' },
            permissions: permisosPacientes,
            selectAllId: 'selectAllPacientes',
        },
        {
            key: 'facturacion',
            title: 'Permisos de Facturación',
            icon: 'fas fa-file-invoice-dollar',
            titleStyle: { color: '#ffc107' },
            permissions: permisosFacturacion,
            selectAllId: 'selectAllFacturacion',
        },
        {
            key: 'contabilidad',
            title: 'Permisos de Contabilidad',
            icon: 'fas fa-calculator',
            titleStyle: { color: '#343a40' },
            permissions: permisosContabilidad,
            selectAllId: 'selectAllContabilidad',
        },
        // Tipo de usuario (profesionalIndependiente) — deprecado: vista_pi en users + toggle header
        {
            key: 'indicadores',
            title: 'Permisos de Indicadores',
            icon: 'fas fa-chart-line',
            titleStyle: { color: '#6f42c1' },
            permissions: permisosIndicadores,
            selectAllId: 'selectAllIndicadores',
        },
        {
            key: 'configuracion',
            title: 'Permisos de Configuración',
            icon: 'fas fa-sliders-h',
            titleStyle: { color: '#343a40' },
            permissions: permisosConfiguracion,
            selectAllId: 'selectAllConfiguracion',
        },
        {
            key: 'laboratorio',
            title: 'Permisos de Laboratorio',
            icon: 'fas fa-flask',
            titleStyle: { color: '#28a745' },
            permissions: permisosLaboratorio,
            selectAllId: 'selectAllLaboratorio',
        },
    ];
}

export function getAllPermissionIds(sections) {
    return sections.flatMap((s) => (s.permissions || []).map((p) => p.id));
}
